import axios from "axios";
import * as Toast from "../lib/toast";
import * as DataServices from "./DataServices";
import { getAuthorization } from "../lib/auth";

export function postMethod(
  Url,
  parametrs = "",
  auth = "false",
  method = "post",
  media = "false",
  add_url = "",
  status_er = true
) {
  var header = [];
  if (media === "false") {
    header = {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
  } else {
    header = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
  }

  if (auth === "true") {
    var token = getAuthorization();

    header["Authorization"] = "Bearer " + token;
  }

  var src = axios({
    method: method,
    url: DataServices.UrlApi(Url) + add_url,
    data: parametrs,
    headers: header,
  })
    .then(function (response) {
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        Toast.ErrorData(response.data.data.message);
      }
    })
    .catch(function (error) {
      if (error.response) {
        if (auth === "true" && error.response.status === 401) {
          window.localStorage.setItem("access_token_sbm", "");

          document.cookie =
            "access_token_sbm=;path=/;domain=" +
            DataServices.webConfig("cookie_key");
          document.cookie =
            "user_id=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "approve=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_image=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_name=;path=/;domain=" + DataServices.webConfig("cookie_key");

          window.location = "/login";
        } else if (error.response.status === 422) {
          const Errors = error.response.data.errors;
          Object.keys(Errors).forEach(function (key) {
            Toast.ErrorData(Errors[key]);
          });
        } else {
          Toast.ErrorData("Unable to access server");
        }
      } else {
        if (status_er)
          Toast.ErrorData(
            "Server access is not possible, please check your internet."
          );
      }
    });

  // doing other something
  return src;
}

export function getMethod(Url, parametrs = "", auth = "false") {
  const header = {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  if (auth === "true") {
    var token = getAuthorization();

    header["Authorization"] = "Bearer " + token;
  }

  if (parametrs) {
    Url = DataServices.UrlApi(Url) + "?" + parametrs;
  } else {
    Url = DataServices.UrlApi(Url);
  }

  var src = axios({
    method: "get",
    url: Url,
    headers: header,
  })
    .then(function (response) {
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        Toast.ErrorData(response.data.data.message);
      }
    })
    .catch(function (error) {
      if (error.response) {
        if (auth === "true" && error.response.status === 401) {
          document.cookie =
            "access_token_sbm=;path=/;domain=" +
            DataServices.webConfig("cookie_key");
          document.cookie =
            "user_id=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "approve=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_image=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_name=;path=/;domain=" + DataServices.webConfig("cookie_key");
          window.localStorage.setItem("access_token_sbm", "");
          window.location = "/login";
        } else if (error.response.status === 422) {
          const Errors = error.response.data.errors;
          Object.keys(Errors).forEach(function (key) {
            Toast.ErrorData(Errors[key]);
          });
        } else {
          Toast.ErrorData("Unable to access server");
        }
      } else {
        Toast.ErrorData(
          "Server access is not possible, please check your internet."
        );
      }
    });

  // doing other something
  return src;
}
export function deleteMethod(Url, parametrs = "", auth = "false") {
  const header = {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  if (auth === "true") {
    var token = getAuthorization();

    header["Authorization"] = "Bearer " + token;
  }

  if (parametrs) {
    Url = DataServices.UrlApi(Url) + parametrs;
  } else {
    Url = DataServices.UrlApi(Url);
  }
  var src = axios({
    method: "delete",
    url: Url,
    headers: header,
  })
    .then(function (response) {
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        Toast.ErrorData(response.data.data.message);
      }
    })
    .catch(function (error) {
      if (error.response) {
        if (auth === "true" && error.response.status === 401) {
          window.localStorage.setItem("access_token_sbm", "");
          document.cookie =
            "access_token_sbm=;path=/;domain=" +
            DataServices.webConfig("cookie_key");
          document.cookie =
            "user_id=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "approve=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_image=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_name=;path=/;domain=" + DataServices.webConfig("cookie_key");
          window.location = "/login";
        } else if (error.response.status === 422) {
          const Errors = error.response.data.errors;
          Object.keys(Errors).forEach(function (key) {
            Toast.ErrorData(Errors[key]);
          });
        } else {
          Toast.ErrorData("Unable to access server");
        }
      } else {
        Toast.ErrorData(
          "Server access is not possible, please check your internet."
        );
      }
    });

  // doing other something
  return src;
}

export function getMethodAuth(Url, parametrs = "", auth) {
  const header = {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  header["Authorization"] = "Bearer " + auth;

  if (parametrs) {
    Url = DataServices.UrlApi(Url) + "?" + parametrs;
  } else {
    Url = DataServices.UrlApi(Url);
  }

  var src = axios({
    method: "get",
    url: Url,
    headers: header,
  })
    .then(function (response) {
      if (response.data.status === "success") {
        return response.data.data;
      } else {
        Toast.ErrorData(response.data.data.message);
      }
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          window.localStorage.setItem("access_token_sbm", "");
          document.cookie =
            "access_token_sbm=;path=/;domain=" +
            DataServices.webConfig("cookie_key");
          document.cookie =
            "user_id=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "approve=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_image=;path=/;domain=" + DataServices.webConfig("cookie_key");
          document.cookie =
            "user_name=;path=/;domain=" + DataServices.webConfig("cookie_key");
          window.location = "/login";
        } else if (error.response.status === 422) {
          const Errors = error.response.data.errors;
          Object.keys(Errors).forEach(function (key) {
            Toast.ErrorData(Errors[key]);
          });
        } else {
          Toast.ErrorData("Unable to access server");
        }
      } else {
        Toast.ErrorData(
          "Server access is not possible, please check your internet."
        );
      }
    });

  // doing other something
  return src;
}
